var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIpowered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94613 1.25V3.71456M16 1.25V3.71456M23.0539 1.25V3.71456M8.94613 28.2854V30.75M16 28.2854V30.75M23.0539 28.2854V30.75M30.75 8.94613H28.2854M30.75 16H28.2854M3.71456 8.94613H1.25M3.71456 16H1.25M3.71456 23.0539H1.25M9.73837 20.4662L13.0436 11.7879C13.1112 11.6228 13.3449 11.6225 13.4128 11.7875L16.6881 20.4662M10.7692 18.3049H15.6739M21.7616 11.5337V20.3361",
    stroke: "url(#paint0_linear_58_1173)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4671 19.4508V6.28293C29.4671 4.21187 27.7881 2.53293 25.7171 2.53293H6.28296C4.2119 2.53293 2.53296 4.21187 2.53296 6.28293V25.7171C2.53296 27.7881 4.2119 29.4671 6.28296 29.4671H25.7171C27.7881 29.4671 29.4671 27.7881 29.4671 25.7171V25.7008",
    stroke: "url(#paint1_linear_58_1173)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_1173",
    x1: 1.08725,
    y1: 16.0001,
    x2: 30.9128,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_1173",
    x1: 2.38437,
    y1: 16.0001,
    x2: 29.6158,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIpowered);
export default __webpack_public_path__ + "static/media/AIpowered.67ab11a1dcf3b56a784024e0cec82c6d.svg";
export { ForwardRef as ReactComponent };